'use strict';

var FoG = window.FoG = window.FoG || {};

FoG.SignalForm = (function($) {
  var $signalForm = null;
  var submitting = false;
  
  function handleSuccess(data) {
    // OLD
    // FoG.Modal.message("Your signal has been submitted, thanks!", () => window.location = '/signals');
    // NEW
    FoG.Modal.message("Your project has been submitted, thanks!", () => window.location = '/signals');
  }
  
  function handleFailure(response) {
    enableSubmit();
    
    if (response && response.status && response.data && response.data['field-errors']) {
      var fieldErrors = response.data['field-errors'];

      $.each(fieldErrors, function(idx, errorText) {
        var $errorField = $signalForm.find('[name=' + idx + ']');
        if (!$errorField.length) { return; }
        
        // Some fields have containers for display purposes.  Errors should be placed outside them.
        var $container = $errorField.closest('[data-input-container]');
        addFormError(errorText, $container.length ? $container : $errorField);
      });

      FoG.Modal.error("There's an error in your submission. Please review the form and try again.");
    }
    else {
      FoG.Modal.error(NA.Ajax.errorFromResponse());
    }      
  }
  
  function addFormError(msg, $errorLocation) {
    var $errorDiv = $('<div class="submitSignal__error"></div>').text(msg);
    
    if ($errorLocation) {
      $errorDiv.insertBefore($errorLocation);
    }
    else {
      $signalForm.prepend($errorDiv);
    }
  }
  
  function disableSubmit() {
    submitting = true;
    $signalForm.find(".submitSignal__btnContainer button").addClass('btn--disabled');
  }
  
  function enableSubmit() {
    submitting = false;
    $signalForm.find(".submitSignal__btnContainer button").removeClass('btn--disabled');
  }
  
  function handleSubmit(e) {
    e.preventDefault();
    $signalForm.find('.submitSignal__error').remove();
    
    if (!submitting) {
      disableSubmit();
      NA.Ajax.postForm($signalForm, 'submitSignal', handleSuccess, handleFailure);
    }
  }
  
  function handleCategoryChange() {
    var $this = $(this);
    var createNewCat = !!$this.find('option[data-signal-create-cat]:selected').length;
    
    $this.closest('.submitSignal__field').find('.newCategoryContainer').toggle(createNewCat);
  }
  
  function initForm(formId) {
    var form  = document.getElementById(formId);
    if (!form) { return; }
    
    $signalForm = $(form);
    $signalForm.find('.submitSignal__btnContainer button').on('click', handleSubmit);
    
    // Remove field-scoped errors when a field changes value.
    $signalForm.on('change', 'textarea, select, input', function() {
      $(this).closest('.submitSignal__field').find('.submitSignal__error').remove();
    });
    
    var $fldCat = $signalForm.find('#fld_category');
    $fldCat.on('change', handleCategoryChange);
    handleCategoryChange.bind($fldCat[0])();
  }
  
  $(() => initForm('signalForm'));
})(jQuery);